import React, { createElement, useEffect, useState } from 'react';
import './index.scss';
import { Tab } from '@alifd/next';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const ITab = (props, ref) => {
    const { data, children, ...other } = props;
    const [error, setError] = useState(false);
    const [defaultKey, setDefaultKey] = useState(data[0]?.primaryKey || null);
    const [tabs, setTabs] = useState([]);
    useEffect(() => {
        setTabs(data);
    }, [data]);
    const close = (key) => {
        const list = tabs.filter(item => item.primaryKey !== key);
        setTabs(list);
        if (list.length) {
            setDefaultKey(list[0]?.primaryKey || null);
        }
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref })) : (createElement("div", { ref: ref, className: "base_bg" },
        createElement(Tab, Object.assign({}, other, { onClose: close, defaultActiveKey: defaultKey }), tabs.map((e, index) => (createElement(Tab.Item, Object.assign({}, e, { key: e.primaryKey }), children[index] ? (children[index]) : (createElement("div", { className: "lc-container-placeholder" }, '拖拽组件或模板到这里'))))))))));
};
export default React.forwardRef(ITab);
